import React from 'react';
import { getRiskLevelColor } from '@abs/shared-logic';
import type { RiskLevel } from '@abs/shared-types';

export interface BudgetGaugeProps {
  used: number;
  total: number;
  riskLevel: RiskLevel;
  label?: string;
}

export function BudgetGauge({
  used,
  total,
  riskLevel,
  label,
}: BudgetGaugeProps): React.ReactElement {
  const percentage = total > 0 ? Math.min(100, (used / total) * 100) : 0;
  const color = getRiskLevelColor(riskLevel);
  const displayLabel = label ?? `${used} / ${total} used`;

  return (
    <div className="budget-gauge" role="meter" aria-valuenow={used} aria-valuemin={0} aria-valuemax={total} aria-label={displayLabel}>
      <div className="budget-gauge__bar">
        <div
          className="budget-gauge__fill"
          style={{ width: `${percentage}%`, backgroundColor: color }}
        />
      </div>
      <span className="budget-gauge__label">{displayLabel}</span>
    </div>
  );
}
